<template>
  <article class="display-inline-block">
    <block
      ref="block"
      :block-color="blockColor"
      :block-hover-primary-color="blockHoverPrimaryColor"
      :block-hover-secondary-color="blockHoverSecondaryColor"
      :block-size="blockSize"
      :coin-color="coinColor"
      :has-tooltip="hasTooltip"
      :is-showing-hover-initially="isShowingHoverInitially"
      :has-hit-bop-limit="hasHitBopLimit"
      @bop="handleBlockInteraction"
    />

    <hud
      :is-showing="isShowingHud"
      :global-bop-count="globalBopCount"
      :one-up-count="oneUpCount"
    />
  </article>
</template>

<script>
  import Block from './Block'
  import Hud from './Hud'

  export default {
    name: 'QuestionMarkBlock',

    components: { Block, Hud },

    props: {
      blockColor: { type: String, default: 'var(--link-color)' },
      blockHoverPrimaryColor: { type: String, default: 'var(--text-color)' },
      blockHoverSecondaryColor: { type: String, default: 'var(--fa-yellow)' },
      blockSize: { type: String, default: '1x' },
      coinColor: { type: String, default: 'var(--fa-dk-yellow)' },
      hasTooltip: { type: Boolean, default: true },
      isShowingHoverInitially: { type: Boolean, default: false }
    },

    data() {
      return {
        canPlaySound: true,
        globalBopCount: 0,
        oneUpCount: 0,
        isShowingHud: false,
        hasHitBopLimit: false
      }
    },

    watch: {
      isShowingHud(newVal) {
        if (!newVal) {
          this.$nextTick(() => {
            const button = this.$refs.block?.$refs?.blockButton
            if (button && typeof button.focus === 'function') {
              button.focus()
            }
          })
        }
      }
    },

    mounted() {
      this.globalBopCount = parseInt(localStorage.getItem('questionMarkBlockBopCount')) || 0
      this.oneUpCount = parseInt(localStorage.getItem('questionMarkBlockOneUpCount')) || 0
    },

    methods: {
      handleBlockInteraction({ bopCount, bopLimitReached }) {
        this.hasHitBopLimit = bopLimitReached

        if (!bopLimitReached) {
          this.globalBopCount++
          localStorage.setItem('questionMarkBlockBopCount', this.globalBopCount)

          if (this.globalBopCount % 100 === 0) {
            this.oneUpCount++
            localStorage.setItem('questionMarkBlockOneUpCount', this.oneUpCount)
            this.playSound('/audio/1up.mp3')
            this.trackEvent('1up', bopCount)
          } else {
            this.playSound('/audio/coin.mp3')
            this.trackEvent('coin', bopCount)
          }
        } else {
          this.playSound('/audio/bump.mp3')
          this.trackEvent('brick', bopCount)
        }

        this.showHud()
      },

      playSound(src) {
        if (!this.canPlaySound) return
        this.canPlaySound = false

        const sound = new Audio(src)
        sound.play().catch(() => {})

        setTimeout(() => {
          this.canPlaySound = true
        }, 100)
      },

      showHud() {
        this.isShowingHud = true
        clearTimeout(this.hudTimeout)
        this.hudTimeout = setTimeout(() => {
          this.isShowingHud = false
        }, 2000)
      },

      trackEvent(reward, bopCount) {
        const eventData = {
          received: reward,
          globalBopCount: this.globalBopCount,
          bopCount,
          $url: this.$route.path
        }
        this.$posthog.capture('funsies:question_mark_block_button_click', eventData)
      }
    }
  }
</script>
